if (!customElements.get('article-related-list')) {
    customElements.define(
        'article-related-list',
        class ArticleRelatedList extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper-container');
            }

            connectedCallback() {
                this.initSwiper();
                window.addEventListener('resize', () => {
                    this.initSwiper();
                })
            }

            initSwiper() {
                if (!this.swiperEl) return;
                const pagination = this.querySelector('.swiper-pagination');
                if (!this.swiperInstance) {
                    this.swiperInstance = new Swiper(this.swiperEl, {
                        spaceBetween: 20,
                        pagination: {
                            el: pagination,
                            clickable: true,
                        }
                    });
                }
                window.relatedSwiper = this.swiperInstance;
                const windowWidth = window.innerWidth;
                console.log("windowWidth", windowWidth);
                if (windowWidth < 1000) {
                    if (!this.swiperInstance) {
                    } else {
                        console.log("初始化");
                        this.swiperInstance.init();
                    }
                } else {
                    if (this.swiperInstance) {
                        console.log("销毁");
                        this.swiperInstance.destroy(false);
                    }
                }
            }
        }
    )
}